export const SectionCard = ({ children }: { children: React.ReactNode }) => (
  <div className="w-full bg-black/10 p-8 flex flex-col gap-4">{children}</div>
);
